import { render, staticRenderFns } from "./StickyElement.vue?vue&type=template&id=6be7facd&scoped=true&"
import script from "./StickyElement.vue?vue&type=script&lang=ts&"
export * from "./StickyElement.vue?vue&type=script&lang=ts&"
import style0 from "./StickyElement.vue?vue&type=style&index=0&id=6be7facd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7facd",
  null
  
)

export default component.exports